export default {
  cancel: {
    zh: '取消',
    en: 'Cancel',
    ja: 'キャンセル',
  },
  confirm: {
    zh: '确定',
    en: 'Confirm',
    ja: '確認',
  },
  inputRequired: {
    zh: '请输入',
    en: 'Please input',
    ja: '入力してください',
  },
  selectRequired: {
    zh: '请选择',
    en: 'Please select',
    ja: '選択してください',
  },
  back: {
    zh: '返回',
    en: 'Back',
    ja: '戻る',
  },
  save: {
    zh: '保存',
    en: 'Save',
    ja: '保存',
  },
  saveOnly: {
    zh: '仅保存',
    en: 'Save Only',
    ja: '保存のみ',
  },
  reset: {
    zh: '重置',
    en: 'Reset',
    ja: 'リセット',
  },
  disable: {
    zh: '禁用',
    en: 'Disable',
    ja: '無効にする',
  },
  enable: {
    zh: '启用',
    en: 'Enable',
    ja: '有効',
  },
  noData: {
    zh: '暂无数据',
    en: 'No Data',
    ja: 'データなし',
  },
  createSuccess: {
    zh: '创建成功',
    en: 'Create Success',
    ja: '新規に成功しました',
  },
  createfailed: {
    zh: '创建失败',
    en: 'Create Failed',
    ja: '新規に失敗しました',
  },
  editSuccess: {
    zh: '编辑成功',
    en: 'Edit Success',
    ja: '更新に成功しました',
  },
  editfailed: {
    zh: '编辑失败',
    en: 'Edit Failed',
    ja: '更新に失敗しました',
  },
  deleteSuccess: {
    zh: '删除成功',
    en: 'Delete Success',
    ja: '削除に成功しました',
  },
  deletefailed: {
    zh: '删除失败',
    en: 'Delete Failed',
    ja: '削除に失敗しました',
  },
  saveSuccess: {
    zh: '保存成功',
    en: 'Save Success',
    ja: '保存に成功しました',
  },
  warning: {
    zh: '提示',
    en: 'Warning',
    ja: 'ワーニング',
  },
  confirmDelete: {
    zh: '此操作将删除 {name}，是否继续？',
    en: 'This will delete {name}, continue?',
    ja: '該当操作は{name}を削除してもよろしいですか？',
  },
  new: {
    zh: '新 建',
    en: 'New',
    ja: '新 規',
  },
  delete: {
    zh: '删 除',
    en: 'Delete',
    ja: '削 除',
  },
  edit: {
    zh: '编 辑',
    en: 'Edit',
    ja: '編 集',
  },
  unitS: {
    zh: '秒',
    en: 's',
    ja: '秒',
  },
  unitMS: {
    zh: '毫秒',
    en: 'ms',
    ja: 'ミリ秒',
  },
  config: {
    zh: '高级配置',
    en: 'Advanced Config',
    ja: '詳細設定',
  },
  copy: {
    zh: '复 制',
    en: 'Copy',
    ja: 'コピー',
  },
  copySuccess: {
    zh: '复制成功',
    en: 'Copy Success',
    ja: 'コピーが成功しました',
  },
  copyFailed: {
    zh: '复制失败',
    en: 'Copy Failed',
    ja: 'コピーが失敗しました',
  },
  version: {
    zh: '版本：',
    en: 'Version: ',
    ja: 'システムバージョン：',
  },
  cloud: {
    zh: '需要一个云原生的全托管 MQTT 服务？一键部署 <a href="https://www.emqx.com/zh/cloud/?utm_source=emqx.io&utm_medium=referral&utm_campaign=mqttx-web-to-cloud" target="_blank" rel="noopener noreferrer">EMQX Cloud</a>！14 天免费试用！',
    en: 'Need a Fully Managed, Cloud-Native MQTT Messaging Service? Try <a href="https://www.emqx.com/en/cloud/?utm_source=emqx.io&utm_medium=referral&utm_campaign=mqttx-web-to-cloud" target="_blank" rel="noopener noreferrer">EMQX Cloud</a> now! 14-day trial, no credit card required.',
    ja: 'フルマネージドのクラウドネイティブMQTTメッセージングサービスが必要ですか？今すぐ <a href="https://www.emqx.com/en/cloud/?utm_source=emqx.io&utm_medium=referral&utm_campaign=mqttx-web-to-cloud" target="_blank" rel="noopener noreferrer">EMQX Cloud</a> をお試しください。30日間の試用版で、クレジットカードは必要ありません。',
  },
}
